<template>
  <div class="nested-menu-tab-drop-down-container">
    <nested-menu-tab-drop-down :title="$t('members')" icon="icon-user" route="configuration.members" :menus="[
      { title: $t('groups'), route: 'configuration.members.groups' },
      { title: $t('levels'), route: 'configuration.members.levels' },
      { title: $t('custom_fields'), route: 'configuration.members.custom_fields' }
    ]"></nested-menu-tab-drop-down>
    <nested-menu-tab-drop-down :title="$tc('consultation')" icon="icon-list" route="configuration.consultation" :menus="[
      { title: $t('inquiry'), route: 'configuration.consultation.inquiry' },
      { title: $tc('department', 2), route: 'configuration.consultation.department' },
      { title: $t('big'), route: 'configuration.consultation.big' },
      { title: $t('small'), route: 'configuration.consultation.small' },
      { title: $t('custom_fields'), route: 'configuration.consultation.custom_fields' }
    ]"></nested-menu-tab-drop-down>
    <nested-menu-tab-drop-down :title="$t('inbound')" icon="icon-phone" route="configuration.inbound" :menus="[
      { title: $t('ring_group'), route: 'configuration.inbound.ringGroup' },
      { title: $t('ivr'), route: 'configuration.inbound.ivr' },
      { title: $t('callback_group'), route: 'configuration.inbound.callbackGroup' }
    ]"></nested-menu-tab-drop-down>
    <nested-menu-tab-drop-down :title="$t('tasks')" icon="icon-list" route="configuration.task" :menus="[
      { title: $t('category'), route: 'configuration.task.category' }
    ]"></nested-menu-tab-drop-down>
  </div>
</template>

<script>
import NestedMenuTabDropDown from '@/components/navigations/NestedMenuTabDropDown'

export default {
  name: 'Shared.Configuration.TabNav',
  components: {
    NestedMenuTabDropDown
  }
}
</script>

<style scoped>

</style>
